/* Shared by every page: mobile menu, the adjustment diagram, and the cart drawer (Shopify Ajax cart). */
(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (id) { return document.getElementById(id); };

  /* ---------- menu ---------- */
  var mb = $("menuBtn"), menu = $("menu");
  if (mb) mb.addEventListener("click", function () { var o = menu.classList.toggle("open"); mb.setAttribute("aria-expanded", String(o)); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && menu && menu.classList.contains("open")) { menu.classList.remove("open"); mb.setAttribute("aria-expanded", "false"); mb.focus(); } });
  if (mb && menu) menu.addEventListener("click", function (e) { if (e.target.closest("a")) { menu.classList.remove("open"); mb.setAttribute("aria-expanded", "false"); } });

  /* ---------- adjustment diagram (landing and How it works) ---------- */
  var st = $("steppers"), dg = $("diagram"), touched = false;
  function setStep(n) {
    st.querySelectorAll("button").forEach(function (x) { x.setAttribute("aria-checked", String(+x.dataset.s === n)); });
    dg.querySelector(".tray-low").style.setProperty("--step", n);
  }
  if (st && dg) {
    st.addEventListener("click", function (e) { var b = e.target.closest("button"); if (!b) return; touched = true; setStep(+b.dataset.s); });
    if (!reduce && "IntersectionObserver" in window) {
      var play = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        play.disconnect();
        var n = 0;
        (function tick() { if (touched || n >= 2) return; n += 1; setStep(n); setTimeout(tick, 900); })();
      }, { threshold: 0.9 });
      play.observe(dg);
    }
  }

  /* the exploded image: its notes appear one after the other when it scrolls into view */
  var mech = document.querySelectorAll(".mech");
  if (mech.length) {
    if (reduce || !("IntersectionObserver" in window)) mech.forEach(function (m) { m.classList.add("on"); });
    else {
      var seen = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("on"); seen.unobserve(e.target); } }); }, { threshold: 0.55 });
      mech.forEach(function (m) { seen.observe(m); });
    }
  }

  document.addEventListener("click", function (e) { if (e.target.closest("[data-print]")) window.print(); });

  /* ---------- cart (Shopify Ajax API: the cart lives on Shopify, this drawer only displays it) ---------- */
  var SIL = window.SILENTRIN || {}, V = SIL.variants || {}, A = function (f) { return (SIL.assets || "") + f; };
  var KITS = {
    hush: { name: "The Hush", desc: "Mouthguard, calibration key, ventilated case", img: A("kit-hush.jpg") },
    fresh: { name: "The Fresh", desc: "Adds a dual-head cleaning brush", img: A("kit-fresh.jpg") },
    ritual: { name: "The Ritual", desc: "Adds the brush and an ultrasonic cleaner (50 kHz, 200 ml)", img: A("kit-ritual.jpg") }
  };
  var ORDER = ["hush", "fresh", "ritual"], BY_ID = {};
  ORDER.forEach(function (o) { var v = V[o] || {}; KITS[o].price = +v.price || 0; KITS[o].id = v.id; if (v.id) BY_ID[v.id] = o; });
  function diff(a, b) { return KITS[b].price - KITS[a].price; }
  var NEXT = { hush: { to: "fresh", add: diff("hush", "fresh"), what: "a dual-head cleaning brush" }, fresh: { to: "ritual", add: diff("fresh", "ritual"), what: "an ultrasonic cleaner (50 kHz, 200 ml)" } };
  var TICK = '<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  var PAY = '<ul class="pay" aria-label="Payment methods">' + [["visa", "Visa"], ["master", "Mastercard"], ["american_express", "American Express"], ["paypal", "PayPal"], ["apple_pay", "Apple Pay"], ["shopify_pay", "Shop Pay"]].map(function (p) { return '<li><img src="' + A("pay-" + p[0] + ".svg") + '" width="38" height="24" alt="' + p[1] + '"></li>'; }).join("") + '</ul>';
  var ASSURE = '<ul class="assure-row" aria-label="Our promises">' +
    '<li><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7"/><circle cx="7.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg><span>Free US shipping</span></li>' +
    '<li><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="M9 12l2.2 2.2L15.5 10"/></svg><span>60-night guarantee</span></li>' +
    '<li><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg><span>Secure checkout</span></li></ul>';
  var cart = null, lines = [], err = "";
  var GENERIC = "We couldn’t update your cart. Please try again, or write to hello@silentrin.com.";
  var money = function (c) { return "$" + (c / 100).toFixed(2); };
  function qtyOf(kit) { return lines.reduce(function (n, l) { return n + (l.kit === kit ? l.qty : 0); }, 0); }
  function count() { return cart ? cart.item_count : 0; }

  var drawer = $("cart"), scrim = document.querySelector("[data-cart-scrim]"), body = document.querySelector("[data-cart-body]"), foot = document.querySelector("[data-cart-foot]"), status = document.querySelector("[data-cart-status]");
  var lastFocus = null;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* one place for every call to Shopify; a failure carries a sentence the customer can read */
  function req(url, data) {
    var opt = data ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(data) } : { headers: { Accept: "application/json" }, cache: "no-store" };
    return fetch(url, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || "request failed"); e.user = r.status === 422 && j.description ? j.description : GENERIC; throw e; }
        return j;
      });
    }, function () { var e = new Error("network"); e.user = GENERIC; throw e; });
  }
  function sync(c) {   /* the cart as Shopify sees it becomes the drawer's lines */
    cart = c; err = "";
    lines = (c.items || []).map(function (it) {
      var kit = BY_ID[it.variant_id];
      return { kit: kit || null, qty: it.quantity, key: it.key, price: it.original_line_price, info: kit ? KITS[kit] : { name: it.variant_title || it.product_title, desc: "", img: it.image || "" } };
    });
    render();
    return c;
  }
  function refresh() { return req("/cart.js").then(sync); }
  function addKit(kit) {
    var v = KITS[kit];
    if (!v || !v.id) { var e = new Error("no variant"); e.user = GENERIC; return Promise.reject(e); }
    return req("/cart/add.js", { items: [{ id: v.id, quantity: 1 }] }).then(refresh);
  }
  function setQty(key, q) { return req("/cart/change.js", { id: key, quantity: Math.max(0, q) }).then(sync); }
  function swapKit(from, to) { var u = {}; u[String(KITS[from].id)] = 0; u[String(KITS[to].id)] = 1; return req("/cart/update.js", { updates: u }).then(sync); }
  function fail(e) { err = (e && e.user) || GENERIC; render(); }

  function render() {
    var n = count();
    document.querySelectorAll("[data-cart-count]").forEach(function (b) { b.textContent = String(n); b.hidden = n === 0; });
    document.querySelectorAll("[data-cart-count-text]").forEach(function (b) { b.textContent = String(n); });
    if (!body) return;
    var alert = err ? '<p class="cart-err" role="alert">' + esc(err) + '</p>' : "";
    if (!lines.length) {   /* empty cart: the three kits, ready to add, then the promises and the payment icons */
      body.innerHTML = alert + '<div class="cart-empty"><b>Your cart is empty</b><ul class="picks">' + ORDER.map(function (o) {
        var k = KITS[o];
        return '<li class="pick"><img class="pick-img" src="' + k.img + '" width="64" height="80" alt="" loading="lazy"><div class="pick-t"><b>' + esc(k.name) + '</b><small>' + esc(k.desc) + '</small></div>' +
          '<div class="pick-r"><span class="pick-p">' + money(k.price) + '</span><button type="button" class="cta ghost pick-add" data-add="' + o + '" aria-label="Add ' + esc(k.name) + ' to cart">Add</button></div></li>';
      }).join("") + '</ul>' + ASSURE + PAY + '</div>';
      foot.innerHTML = ""; foot.hidden = true; upbar(); return;
    }
    var html = alert;
    lines.forEach(function (l, i) {
      var k = l.info;
      html += '<div class="line"><img class="line-img" src="' + k.img + '" width="72" height="90" alt="' + esc(k.name) + ' kit" loading="lazy"><div class="line-t"><b>' + esc(k.name) + '</b><small>' + esc(k.desc) + '</small></div><span class="line-p">' + money(l.price) + '</span>' +
        '<div class="qty" role="group" aria-label="Quantity of ' + esc(k.name) + '"><button type="button" data-q="-1" data-i="' + i + '" aria-label="Decrease quantity of ' + esc(k.name) + '">−</button><output aria-live="polite">' + l.qty + '</output><button type="button" data-q="1" data-i="' + i + '" aria-label="Increase quantity of ' + esc(k.name) + '">+</button></div>' +
        '<button type="button" class="rm" data-rm="' + i + '" aria-label="Remove ' + esc(k.name) + '">Remove</button></div>';
    });
    if (SIL.coupleOffer && lines.length === 1 && lines[0].kit === "hush" && lines[0].qty === 1) {   /* only once the automatic discount exists in Shopify */
      html += '<div class="offer"><b>Sharing a bed?</b><p>Two of The Hush for $79.98. Save $20.</p><button type="button" class="cta ghost" data-add="hush">Add a second Hush</button></div>';
    }
    html += '<p class="note assure-note">Questions? <a href="mailto:hello@silentrin.com">hello@silentrin.com</a></p>';
    body.innerHTML = html; upbar();
    var d = cart.total_discount || 0;
    foot.hidden = false;
    foot.innerHTML = '<dl class="sums"><div><dt>Subtotal</dt><dd>' + money(cart.original_total_price) + '</dd></div>' +
      (d ? '<div><dt>Couple’s Kit</dt><dd>−' + money(d) + '</dd></div>' : '') +
      (SIL.coupleOffer && qtyOf("hush") > 2 ? '<p class="note">The Couple’s Kit discount applies to 2 items.</p>' : '') +
      '<div><dt>Shipping</dt><dd>Free (US)</dd></div></dl>' +
      '<a class="cta" href="/checkout">Checkout · ' + money(cart.total_price) + '</a>' + ASSURE + PAY;
  }
  function upbar() {   /* the bar at the top of the drawer: where you are among the three kits, and the way up. From The Hush the main offer is The Ritual (our most complete kit); the brush alone stays one tap away. */
    var el = document.querySelector("[data-cart-up]"); if (!el) return;
    if (lines.length !== 1 || lines[0].qty !== 1 || !lines[0].kit) { el.hidden = true; el.innerHTML = ""; return; }
    var k = lines[0].kit, at = ORDER.indexOf(k);
    var n = k === "hush" ? { to: "ritual", add: diff("hush", "ritual"), what: "the brush and an ultrasonic cleaner (50 kHz, 200 ml)" } : NEXT[k];
    var target = n ? ORDER.indexOf(n.to) : -1;
    var steps = ORDER.map(function (o, i) { return '<li class="' + (i <= at ? "done" : i === target ? "next" : "") + '"><span>' + esc(KITS[o].name.replace("The ", "")) + '</span></li>'; }).join("");
    el.hidden = false;
    el.innerHTML = '<ol class="upsteps" aria-label="The three kits">' + steps + '</ol>' +
      (n ? '<div class="upmsg"><p><b>' + esc(KITS[n.to].name) + '</b> adds ' + esc(n.what) + ' for ' + money(n.add) + ' more.</p><button type="button" class="cta ghost" data-up="' + n.to + '">Upgrade · +' + money(n.add) + '</button></div>' +
        (k === "hush" ? '<button type="button" class="upalt" data-up="fresh">Or add only the brush: +' + money(NEXT.hush.add) + '</button>' : "") : '<p class="upmsg-done">You have our most complete kit.</p>');
  }
  function busy(work, after) {   /* one change at a time: the drawer is locked (aria-busy) until Shopify answers */
    if (drawer && drawer.getAttribute("aria-busy") === "true") return;
    if (status) status.textContent = "Updating your cart…";
    if (drawer) drawer.setAttribute("aria-busy", "true");
    work().then(function () { if (status) status.textContent = "Cart updated."; }, function (e) { fail(e); if (status) status.textContent = ""; })
      .then(function () { if (drawer) drawer.removeAttribute("aria-busy"); if (after) after(); });
  }
  function refocus(sels) {   /* render() rebuilds the drawer, so give the keyboard focus back to the same kind of control */
    if (!drawer) return;
    for (var k = 0; k < sels.length; k++) { var el = drawer.querySelector(sels[k]); if (el) { el.focus(); return; } }
  }
  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement; drawer.hidden = false; scrim.hidden = false; document.documentElement.classList.add("cart-open");
    requestAnimationFrame(function () { drawer.classList.add("on"); scrim.classList.add("on"); var c = drawer.querySelector("[data-close-cart]"); if (c) c.focus(); });
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove("on"); scrim.classList.remove("on"); document.documentElement.classList.remove("cart-open");
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, reduce ? 0 : 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-open-cart],[data-close-cart],[data-q],[data-rm],[data-up],[data-add]"); if (!t) return;
    if (t.hasAttribute("data-open-cart")) { open(); return; }
    if (t.hasAttribute("data-close-cart")) { close(); return; }
    if (t.dataset.q) { var i = +t.dataset.i, d = +t.dataset.q; busy(function () { var l = lines[i]; return l ? setQty(l.key, l.qty + d) : Promise.resolve(); }, function () { refocus(['[data-q="' + d + '"][data-i="' + i + '"]', "[data-rm]", "[data-close-cart]"]); }); return; }
    if (t.dataset.rm) { var r = +t.dataset.rm; busy(function () { var l = lines[r]; return l ? setQty(l.key, 0) : Promise.resolve(); }, function () { refocus(["[data-rm]", "[data-close-cart]"]); }); return; }
    if (t.dataset.up) { var u = t.dataset.up; busy(function () { var l = lines[0]; return l && l.kit ? swapKit(l.kit, u) : Promise.resolve(); }, function () { refocus(['[data-q="1"][data-i="0"]', "[data-close-cart]"]); }); return; }
    if (t.dataset.add) { var a = t.dataset.add; busy(function () { return addKit(a); }, function () { refocus(['[data-q="1"][data-i="0"]', "[data-close-cart]"]); }); }
  });
  document.addEventListener("keydown", function (e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === "Escape") { close(); return; }
    if (e.key === "Tab") {
      var f = Array.prototype.slice.call(drawer.querySelectorAll("a[href],button:not([disabled])")).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  if (scrim) scrim.addEventListener("click", close);
  window.addEventListener("pageshow", function (e) { if (e.persisted) refresh().catch(function () {}); });   /* back button: the cart may have changed at checkout */
  document.addEventListener("visibilitychange", function () { if (!document.hidden && cart) refresh().catch(function () {}); });
  window.Cart = {
    add: function (k) { return addKit(k).then(function () { open(); }, function (e) { fail(e); open(); throw e; }); },
    open: open, close: close, count: count,
    clear: function () { return req("/cart/clear.js", {}).then(sync); },
    lines: function () { return lines.slice(); }
  };
  refresh().catch(function () {});   /* until Shopify answers, the header keeps the count the server printed */

})();
